import React from 'react';
import { styles } from './CompetitionDateCallout.css';
import ClosedSignIcon from '@jbhi-fi/lanyard-ui/components/Icons/ClosedSign';
import MedalIcon from '@jbhi-fi/lanyard-ui/components/Icons/Medal';
import TrophyIllustratedIcon from '@jbhi-fi/lanyard-ui/components/Icons/TrophyIllustrated';

export interface CompetitionDateCalloutProps {
  endDate: string;
  winnerAnnouncementDate: string;
  enteredOn?: string;
  isBallot?: boolean;
}

export const CompetitionDateCallout = ({
  endDate,
  winnerAnnouncementDate,
  enteredOn,
  isBallot,
}: CompetitionDateCalloutProps) => {
  return (
    <div>
      {enteredOn ? (
        <div className={styles.enteredContainer}>
          <div className={styles.innerContainer}>
            <TrophyIllustratedIcon className={styles.icon} />
            <div>
              <div className={styles.headingContainer}>{`${isBallot ? 'Ballot' : 'Competition'} entered`}</div>
              <div className={styles.dateContainer}>{enteredOn}</div>
            </div>
          </div>
        </div>
      ) : null}
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <ClosedSignIcon className={styles.icon} />
          <div>
            <div className={styles.headingContainer}>{`${isBallot ? 'Ballot' : 'Competition'} closes`}</div>
            <div className={styles.dateContainer}>{endDate}</div>
          </div>
        </div>
        <div className={styles.innerContainer}>
          <MedalIcon className={styles.icon} />
          <div>
            <div className={styles.headingContainer}>{isBallot ? 'Ballot winners announced' : 'Winners announced'}</div>
            <div className={styles.dateContainer}>{winnerAnnouncementDate}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
